<template>
  <ValidationObserver
    v-slot="{ invalid }"
  >
    <ModalConfirmation
      :isDisabledPrimary="invalid"
      :isLoadingPrimary="loading"
      :showModal="showModal"
      :title="isEdit ? 'Modify Saved View' : 'Create Saved View'"
      @cancel="handleCancel"
      @save="handleSave"
    >
      <template v-slot:body>
        <div
          :class="$style.modalContent"
        >
          <InputText
            v-if="!isEdit"
            :autofocus="true"
            :class="$style.input"
            label="Name"
            name="name"
            placeholder="Saved View Name"
            required
            rules="required|unique"
            :value="viewName"
            @input="handleInput"
          />
          <ParagraphBody
            v-else
          >
            Are you sure you want to modify the Saved View, <b>{{ savedView.name }}</b>?
          </ParagraphBody>
        </div>
      </template>
    </ModalConfirmation>
  </ValidationObserver>
</template>

<script>
import {
  InputText,
  ModalConfirmation,
  ParagraphBody,
  addValidationRule,
} from '@jumpcloud/ui-components';
import { ValidationObserver } from 'vee-validate3';
import {
  mapState,
} from 'vuex';

const cloudInsightsEventsModule = 'CloudInsightsEventsCollection';

export default {
  name: 'CloudInsightsAddViewModal',

  components: {
    InputText,
    ModalConfirmation,
    ParagraphBody,
    ValidationObserver,
  },

  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    savedView: {
      type: Object,
      default: null,
    },
    showModal: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      viewName: '',
    };
  },

  computed: {
    ...mapState(cloudInsightsEventsModule, [
      'savedViews',
    ]),
  },

  created() {
    const { savedViews } = this;
    addValidationRule('unique', {
      message() {
        return 'name already exists';
      },
      validate(value) {
        return !savedViews.map(d => d.name).includes(value);
      },
    });
  },

  methods: {
    handleCancel() {
      this.viewName = '';
      this.$emit('cancel');
    },

    handleInput(input) {
      this.viewName = input;
    },

    handleSave() {
      if (this.isEdit) {
        return this.$emit('edit');
      }
      return this.$emit('save', this.viewName);
    },
  },
};
</script>

<style scoped module>
.input {
  flex: 1;
}

.modalContent {
  align-items: center;
  display: flex;
  height: 85px;
}
</style>
